import React from 'react';
import Slider from 'react-slick';
import './Projects.css';

// Sample project data with images and GitHub links
const projects = [

    {
        src: './employee-directory.png',
        alt: 'Project 1',
        link: 'https://dainty-pixie-199f33.netlify.app'
    },
    {
        src: './drumkit.png',
        alt: 'Project 2',
        link: 'https://tanmaymhaske.github.io/DrumKit/'
    },
    {
        src: '/bookstore.png',
        alt: 'Project 3',
        link: 'https://github.com/TanmayMhaske/bookstore-mern-stack-crud'
    },
    {
        src: '/github.webp',
        alt: 'Project 4',
        link: 'https://github.com/TanmayMhaske/'
    },
];

const Projects = () => {
    // Slider settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className="projects">
            <h2 data-aos="fade-right">Projects</h2>
            <p data-aos="fade-up" data-aos-delay="200">Here are some of my fun projects and git repository link.</p>
            <Slider {...settings} className="projects-carousel">
                {projects.map((project, index) => (
                    <a href={project.link} target="_blank" rel="noopener noreferrer" key={index} className="project-slide">
                        <img src={project.src} alt={project.alt} />
                    </a>
                ))}
            </Slider>
        </div>
    );
}

export default Projects;